export const stringUtil = {
  pluralizeIfNeeded: (params: { itemCount: number; singular: string; plural?: string }): string => {
    const { itemCount = 0, singular, plural = `${singular}s` } = params
    return Math.abs(itemCount) === 1 ? `1 ${singular}` : `${itemCount} ${plural}`
  },
  getDisplayName: (hustler: { username?: string; name?: string } | null | undefined): string => {
    if (!hustler) return 'Hustler'

    // Prefer username if available, fallback to name
    const displayValue = hustler.username || hustler.name
    if (!displayValue) return 'Hustler'

    // Check if it looks like an email
    if (displayValue.includes('@')) {
      return displayValue.split('@')[0]
    }

    return displayValue
  },
  needsUsernameUpdate: (username: string | undefined | null): boolean => {
    if (!username) return true
    if (username.includes('@')) return true // Email format
    return false
  },
  initials: (name: string): string => {
    if (!name) return 'U'
    const parts = name.split(' ')
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase()
    return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase()
  },
}
